// Custom FAQ accordion Script
document.addEventListener("DOMContentLoaded", function () {
  var acc = document.getElementsByClassName("custom-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("custom-active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all buttons on the page
  const toggleButtons = document.querySelectorAll('.custom-read-more .toggle-btn');

  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Finds the specific container for the button clicked
      const parent = this.closest('.custom-read-more');
      const moreText = parent.querySelector('.more-text');
      const ellipsis = parent.querySelector('.ellipsis');
      const contentBox = parent.querySelector('.content-box');

      if (moreText.style.display === "none" || moreText.style.display === "") {
        moreText.style.display = "inline";
        ellipsis.style.display = "none";
        contentBox.style.display = "block";
        this.innerText = "Show Less";
      } else {
        moreText.style.display = "none";
        ellipsis.style.display = "inline";
        contentBox.style.display = "flex";
        this.innerText = "View More";
      }
    });
  });
});